import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivityPageComponent } from './activity-page.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';//图片懒加载
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot([{ path: 'activityPage', component:  ActivityPageComponent}]),
        FormsModule,
        ReactiveFormsModule,
        LazyLoadImageModule
    ],
    exports: [],
    declarations: [
        ActivityPageComponent
    ],
    providers: [],
})
export class ActivityPageModule{

}